import React from 'react';

import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';
import ModalScreen from '@zvuk-b2b/react-uikit/ui/ModalScreen';

import { TEXTS } from './texts';

interface ILoginRequiredModalProps {
  onCancel: () => void;
  onSubmit: () => void;
  content: string;
}

const LoginRequiredModal: React.FC<ILoginRequiredModalProps> = ({ onCancel, onSubmit, content }) => (
  <ModalScreen
    title={TEXTS.LOGIN_REQUIRED_TITLE}
    titlePlacement="center"
    onClose={onCancel}
    actionButtons={[
      <Button
        key="button_confirm_login_required_modal"
        elementId="button_confirm_login_required_modal"
        type={ButtonType.PRIMARY}
        onClick={onSubmit}>
        {TEXTS.LOGIN_TO_ACCOUNT}
      </Button>,
      <Button
        key="button_cancel_login_required_modal"
        elementId="button_cancel_login_required_modal"
        type={ButtonType.SECONDARY}
        onClick={onCancel}>
        {TEXTS.CANCEL}
      </Button>,
    ]}>
    <div>{content}</div>
  </ModalScreen>
);

export default LoginRequiredModal;
